import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LabelType, Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-assign-to-level',
  templateUrl: './assign-to-level.component.html',
  styleUrls: ['./assign-to-level.component.scss']
})
export class AssignToLevelComponent implements OnInit {
  @Input() selMenu: string = 'level';
  public list: Array<any> = [];
  public roleLevelList: Array<any> = [];
  public roleList: any = [];
  public form: FormGroup = new FormGroup({
    id: new FormControl("", [Validators.required]),
    name: new FormControl("", [Validators.required]),
    description: new FormControl(null, [Validators.required]),
  });
  public selected: any = null;
  public commonModal: any;

  public options: Options = {
    floor: 0,
    ceil: 0,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return '<b>Level:</b>' + value;
        case LabelType.High:
          return '<b>Level:</b>' + value;
        default:
          return '' + value;
      }
    },
  };


  constructor(
    private auth: AuthServiceService,
    private modalService: NgbModal,
    private toastr: ToastrService) {

  }

  ngOnInit(): void {
    this._getList();
    this._getAllRoleList();
    this._getAllMemberRoleLevel();
  }

  public add(modal: any, selected: any = null) {
    if (selected) {
      this.form.patchValue({
        id: selected?.levelID,
        name: selected?.levelName,
        description: selected?.description,
      })
      this.selected = selected;
    } else {
      this.selected = null;
      this.form.reset();
    }
    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  public addSubmit() {
    let payload = {
      levelID: this.form.get("id").value,
      levelName: this.form.get("name").value,
      description: this.form.get("description").value
    }
    if (this.selected) {
      payload['action'] = 'edit';
    }

    this.auth.addMemberLevels(payload).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.commonModal ? this.commonModal.close() : '';
      this._getList();
      this.selected = null;
    }, (error: any) => {
      this.toastr.error("Error Please try again!");
    })
  }

  private _getList() {
    this.auth.getAllMemberLevelsRelationship().subscribe((resp: ApiResponse) => {
      this.list = resp.body;
      this.options = {
        floor: 0,
        ceil: this.list.length || 0,
        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>Level:</b>' + value;
            case LabelType.High:
              return '<b>Level:</b>' + value;
            default:
              return '' + value;
          }
        },
      };

    })
  }

  private _getAllMemberRoleLevel() {
    this.auth.getAllMemberRoleLevel().subscribe((resp: ApiResponse) => {
      this.roleLevelList = resp.body.map((i) => {
        let levels = i.roleLevels.map(i => i.levelID);
        let max = levels.length == 0 ? 0 : Math.max(...levels) || 0;
        let min = levels.length == 0 ? 0 : Math.min(...levels) || 0;

        return {
          roleId: i?.roleId,
          description: i?.description,
          roleName: i?.roleName,
          createdAt: i?.createdAt,
          level: levels,
          maxLevel: max,
          minLevel: min,
        };
      });
    })
  }


  public deleteItem(id: any) {
    this.auth.deleteMemberLevels(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getList();
    }, ({ error }) => {
      this.toastr.error("Remove All Dependency before Deleting!");
    })
  }

  public deleteMemberLevels(id: any) {
    this.auth.deleteMemberRole(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getList();
    }, ({ error }) => {
      this.toastr.error("Remove All Dependency before Deleting!");
    })
  }

  public deleteMemberLevelsRelationship(id: any) {
    this.auth.deleteMemberLevelsRelationship(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getList();
    }, ({ error }) => {
      this.toastr.error("Remove All Dependency before Deleting!");
    })
  }

  public addRoleToLevel(levelID, currentRoleList) {
    if (this.selected) {
      if (currentRoleList.filter((i) => i.roleId == this.selected && i.levelID == levelID).length > 0) {
        this.toastr.error("Role Already Present!");
      } else {
        this.auth.addMemberLevelsRelationship({ roleId: this.selected, levelID: levelID }).subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this._getList();
          this.selected = null;
        }, (error: any) => {
          this.toastr.error("Error Please try again!");
        });
      }
    } else {
      this.toastr.error("Select Permissions !");
    }
  }

  private _getAllRoleList() {
    this.auth.getAllMemberRole().subscribe((resp: ApiResponse) => {
      this.roleList = resp.body;
    })
  }

  public onRoleChange(value) {
    this.selected = value;
  }

  public selectMenu(menu: string) {
    this.selMenu = menu;
    this._getList();
    this._getAllRoleList();
    this._getAllMemberRoleLevel();
  }

  public saveLevel(selected: any) {
    this.auth.updateBulkLevelsToRole({ roleId: selected?.roleId, levelIDs: [...Array(selected.maxLevel + 1).keys()].slice(selected.minLevel) }).subscribe((resp: ApiResponse) => {
      this._getAllMemberRoleLevel();
      this.toastr.success(resp.message);
    }, ({ error }: any) => {
      this.toastr.error(error.message);
    });
  }

  public deleteLevel(selected: any) {
    this.auth.updateBulkLevelsToRole({ roleId: selected?.roleId, levelIDs: [] }).subscribe((resp: ApiResponse) => {
      this._getAllMemberRoleLevel();
    }, ({ error }: any) => {
      this.toastr.error(error.message);
    })
  }
}
